module.exports = __webpack_public_path__ + "static/img/search.d36d2d1d.png";